import {SyncEventType} from '../../enums/syncEventType';
import {PersistenceEvent} from './persistenceEvent';

export class EventIssueToForeground implements PersistenceEvent {

  public readonly type = SyncEventType.ISSUECARD_FOCUS;
  public issueId: number;
  public avatar: string;

  constructor(issueId: number, avatar: string) {
    this.issueId = issueId;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventIssueToForeground {
    return new EventIssueToForeground(
      payload['issueId'], payload['avatar']
    );
  }

}

